import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

/**
 * Componente reutilizável para copiar texto para a área de transferência
 * @param {string} textToCopy - Texto que será copiado
 * @param {string} variant - Variante do botão (primary, secondary, outline-primary, etc)
 * @param {string} size - Tamanho do botão (sm, md, lg)
 * @param {string} className - Classes CSS adicionais
 * @param {boolean} showText - Se deve mostrar o texto "Copiar" ou apenas o ícone
 * @param {string} successMessage - Mensagem de sucesso personalizada
 * @param {boolean} showTooltip - Se deve mostrar tooltip
 */
const CopyButton = ({ 
    textToCopy, 
    variant = 'outline-primary', 
    size = 'sm',
    className = '',
    showText = true,
    label = null,
    successMessage = null,
    showTooltip = true
}) => {
    const { t } = useTranslation();

    const handleCopy = async () => {
        if (!textToCopy) return;

        try {
            await navigator.clipboard.writeText(textToCopy);
            toast.success(successMessage || t('copy.success'));
        } catch (err) {
            console.error('Erro ao copiar:', err);
            toast.error(t('copy.error'));
        }
    };

    const button = (
        <Button
            variant={variant}
            size={size}
            onClick={handleCopy}
            className={className}
            disabled={!textToCopy}
        >
            <i className={`fa-regular fa-copy ${showText ? 'me-1' : ''}`.trim()}></i>
            {showText && (label || t('copy.copy'))}
        </Button>
    );

    if (showTooltip && !showText) {
        return (
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{t('copy.copy')}</Tooltip>}
            >
                {button}
            </OverlayTrigger>
        );
    }

    return button;
};

export default CopyButton;
